var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHorses = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.175,
    height: 23.238,
    viewBox: "0 0 25.175 23.238",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "horse-head-solid-svgrepo-com",
    d: "M22.365,4a4.727,4.727,0,0,0-3.873,2.088V4.968C3.178,4.968,3,27.015,3,27.238H6.873a34.336,34.336,0,0,1,1.483-9.38,16.093,16.093,0,0,1,3.51-6.294,8.768,8.768,0,0,1,6.626-2.723H19.1L19.37,8.3A6.343,6.343,0,0,1,21.4,6.239V9.083l3.964,7.928.091.151.121.121a2.115,2.115,0,0,1,.605.938c.053.163.03.159.03.182a1.854,1.854,0,0,1-.242.575c-.212.337-.4.514-.7.514s-.484-.178-.7-.514a2.729,2.729,0,0,1-.3-.7l-.212-.817-.847.091a4.929,4.929,0,0,1-1.694-.151,2.634,2.634,0,0,1-2.088-2.027L19.1,14.136l-1.089.635a4.123,4.123,0,0,0-2.118,3,7.042,7.042,0,0,0,.605,3.328c.813,2.171,2,4.384,2,6.142h1.936c0-2.538-1.418-4.894-2.148-6.838a5.429,5.429,0,0,1-.454-2.39,1.742,1.742,0,0,1,.454-.968A5.088,5.088,0,0,0,21,19.28a4.122,4.122,0,0,0,1.694.151,2.069,2.069,0,0,0,.242.575,2.62,2.62,0,0,0,4.66,0,4.832,4.832,0,0,0,.545-1.241l.03-.091v-.091a3.416,3.416,0,0,0-.151-.968,4.439,4.439,0,0,0-.938-1.452h.03L23.333,8.6V4ZM17.978,6.935c0,.008-.027.023-.03.03-.393.019-.775.038-1.15.091-.3.042-.59.117-.877.182.287-.076.575-.132.877-.182A9.808,9.808,0,0,1,17.978,6.935ZM21.4,11.746a.968.968,0,1,0,.968.968A.97.97,0,0,0,21.4,11.746Z",
    transform: "translate(-3 -4)",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHorses);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/horses.7e9321f54e44efbcacdd99988099444c.svg";